import UserPreferences from './UserPreferences.jsx';

export default UserPreferences;
